export const COURSE_FILE_MAX_SIZE = 500e6; // 500MB

export const COURSE_THUMBNAIL_MAX_SIZE = 2e6; // 2MB

export const COURSE_THUMBNAIL_ACCEPTED_FORMATS = [
  '.png',
  '.jpg',
  '.jpeg',
  '.svg',
  '.gif',
];

export const SLIDE_IMAGE_ACCEPTED_FORMATS = ['.png', '.jpg', '.jpeg', '.gif'];
export const QUIZ_IMAGE_ACCEPTED_FORMATS = [
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.mp4',
];
